module.exports = __webpack_public_path__ + "img/game-maskTip.35ae1fdc.png";